import { INavLayout } from './navModel';

/**
 * The order of the main menu. The only place where the order is decided: to move an item, move its
 * id to another position or another group; to reorder groups, move a whole line; to nest items
 * under an entry, write `{ id, children }` in its place (a pinned group nests the same way, inside
 * its callout). Nothing else changes, because an item's
 * icon, route, label and visibility rule live in navItems.ts and travel with it.
 *
 * `body` scrolls; `footer` is pinned to the bottom of the rail. A group whose items are all
 * invisible for the current user is dropped, caption and all. The user can close a group by its
 * caption unless it says `isCollapsible: false`.
 */
export const navLayout: INavLayout = {
  body: [
    {
      caption: 'start',
      // The entry group, where everyone begins; it stays open.
      isCollapsible: false,
      items: ['start', 'projects', { id: 'standards', children: ['standards-overview', 'themes', 'controls'] }],
    },
    { caption: 'organization', items: ['processes', 'objectives', 'kpis', 'library'] },
    { caption: 'riskManagement', items: ['assets', 'risks', 'processingactivities'] },
    { caption: 'planningAndWork', items: ['tasks', 'schedule', 'audits'] },
  ],
  footer: [
    {
      header: 'admin',
      items: [
        'admin-reports',
        'admin-store',
        'admin-standards',
        'admin-settings',
        'admin-groups',
        'admin-content',
        'admin-auth',
        'admin-subscription',
        'admin-orgunits',
      ],
    },
    {
      header: 'partneradmin',
      items: ['partneradmin-customers', 'partneradmin-dashboard'],
    },
    {
      header: 'tenantadmin',
      items: [
        'tenantadmin-announcements',
        'tenantadmin-controls',
        'tenantadmin-manage',
        'tenantadmin-logs',
        'tenantadmin-identity-issuers',
        {
          id: 'tenantadmin-ai',
          children: [
            'tenantadmin-ai-trace',
            'tenantadmin-ai-audit-trace',
            'tenantadmin-ai-credits',
            'tenantadmin-ai-instructions',
            'tenantadmin-ai-skills',
            'tenantadmin-documents',
            'tenantadmin-ai-standard-input',
          ],
        },
      ],
    },
  ],
};
